import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const LANGS = ["En", "Ar", "Ku"];

const VoyahCourageSpecificationEditor = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  // GROUP MODAL
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [groupForm, setGroupForm] = useState({
    id: null,
    order: 1,
    titleEn: "",
    titleAr: "",
    titleKu: "",
  });

  // ROW MODAL
  const [showRowModal, setShowRowModal] = useState(false);
  const [rowForm, setRowForm] = useState({
    id: null,
    groupId: null,
    order: 1,
    labelEn: "",
    labelAr: "",
    labelKu: "",
    twoWdValueEn: "",
    twoWdValueAr: "",
    twoWdValueKu: "",
    fourWdValueEn: "",
    fourWdValueAr: "",
    fourWdValueKu: "",
  });

  // ============================================================
  // LOAD ADMIN DATA
  // ============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(`${API_BASE}/api/VoyahCourageSpec/admin`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setGroups(res.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    load();
  }, []);

  // ============================================================
  // GROUP FUNCTIONS
  // ============================================================

  const openNewGroup = () => {
    setGroupForm({
      id: null,
      order: 1,
      titleEn: "",
      titleAr: "",
      titleKu: "",
    });
    setShowGroupModal(true);
  };

  const openEditGroup = (g) => {
    setGroupForm({
      id: g.id,
      order: g.order,
      titleEn: g.titleEn,
      titleAr: g.titleAr,
      titleKu: g.titleKu,
    });
    setShowGroupModal(true);
  };

  const saveGroup = async () => {
    const token = localStorage.getItem("token");

    try {
      if (groupForm.id === null) {
        // CREATE
        await axios.post(
          `${API_BASE}/api/VoyahCourageSpec/group`,
          {
            order: groupForm.order,
            titleEn: groupForm.titleEn,
            titleAr: groupForm.titleAr,
            titleKu: groupForm.titleKu,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        // UPDATE
        await axios.put(
          `${API_BASE}/api/VoyahCourageSpec/group/${groupForm.id}`,
          {
            order: groupForm.order,
            titleEn: groupForm.titleEn,
            titleAr: groupForm.titleAr,
            titleKu: groupForm.titleKu,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Failed to save group.");
    }
  };

  const deleteGroup = async (id) => {
    if (!window.confirm("Delete this group?")) return;

    const token = localStorage.getItem("token");

    try {
      await axios.delete(`${API_BASE}/api/VoyahCourageSpec/group/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Delete failed.");
    }
  };

  // ============================================================
  // ROW FUNCTIONS
  // ============================================================

  const openNewRow = (groupId) => {
    setRowForm({
      id: null,
      groupId,
      order: 1,
      labelEn: "",
      labelAr: "",
      labelKu: "",
      twoWdValueEn: "",
      twoWdValueAr: "",
      twoWdValueKu: "",
      fourWdValueEn: "",
      fourWdValueAr: "",
      fourWdValueKu: "",
    });
    setShowRowModal(true);
  };

  const openEditRow = (row) => {
    setRowForm({
      id: row.id,
      groupId: row.groupId,
      order: row.order,
      labelEn: row.labelEn,
      labelAr: row.labelAr,
      labelKu: row.labelKu,
      twoWdValueEn: row.twoWdValueEn,
      twoWdValueAr: row.twoWdValueAr,
      twoWdValueKu: row.twoWdValueKu,
      fourWdValueEn: row.fourWdValueEn,
      fourWdValueAr: row.fourWdValueAr,
      fourWdValueKu: row.fourWdValueKu,
    });
    setShowRowModal(true);
  };

  const saveRow = async () => {
    const token = localStorage.getItem("token");

    try {
      if (rowForm.id === null) {
        // CREATE
        await axios.post(
          `${API_BASE}/api/VoyahCourageSpec/row`,
          rowForm,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        // UPDATE
        await axios.put(
          `${API_BASE}/api/VoyahCourageSpec/row/${rowForm.id}`,
          rowForm,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Failed to save row.");
    }
  };

  const deleteRow = async (id) => {
    if (!window.confirm("Delete this row?")) return;

    const token = localStorage.getItem("token");

    try {
      await axios.delete(`${API_BASE}/api/VoyahCourageSpec/row/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Delete failed.");
    }
  };

  // ============================================================
  // RENDER
  // ============================================================

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Voyah COURAGE – Specification Editor</h2>

      {/* GROUP LIST */}
      {groups.map((g) => (
        <div className="card mb-4 shadow-sm" key={g.id}>
          <div className="card-body">
            <h4 className="mb-3">
              Group #{g.id} — {g.titleEn}
            </h4>

            <button
              className="btn btn-primary btn-sm mb-3"
              onClick={() => openNewRow(g.id)}
            >
              + Add Row
            </button>

            {/* ROW LIST */}
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Label (EN)</th>
                  <th>2WD (EN)</th>
                  <th>4WD (EN)</th>
                  <th style={{ width: "180px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {g.rows.map((r) => (
                  <tr key={r.id}>
                    <td>{r.order}</td>
                    <td>{r.labelEn}</td>
                    <td>{r.twoWdValueEn}</td>
                    <td>{r.fourWdValueEn}</td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm me-2"
                        onClick={() => openEditRow(r)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => deleteRow(r.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* GROUP ACTIONS */}
            <div className="d-flex gap-2 mt-3">
              <button
                className="btn btn-warning"
                onClick={() => openEditGroup(g)}
              >
                Edit Group
              </button>

              <button
                className="btn btn-danger"
                onClick={() => deleteGroup(g.id)}
              >
                Delete Group
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* ADD GROUP BUTTON */}
      <button className="btn btn-success mt-4" onClick={openNewGroup}>
        + Add New Group
      </button>

      {/* ============================================================ */}
      {/* GROUP MODAL */}
      {/* ============================================================ */}
      {showGroupModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {groupForm.id === null ? "Add Group" : "Edit Group"}
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowGroupModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <label className="form-label">Order</label>
                  <input
                    className="form-control mb-3"
                    type="number"
                    value={groupForm.order}
                    onChange={(e) =>
                      setGroupForm({ ...groupForm, order: Number(e.target.value) })
                    }
                  />

                  {LANGS.map((lang) => (
                    <div key={lang} className="mb-3">
                      <label className="form-label">{`Title ${lang}`}</label>
                      <input
                        className="form-control"
                        value={groupForm[`title${lang}`]}
                        onChange={(e) =>
                          setGroupForm({
                            ...groupForm,
                            [`title${lang}`]: e.target.value,
                          })
                        }
                      />
                    </div>
                  ))}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowGroupModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={saveGroup}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}

      {/* ============================================================ */}
      {/* ROW MODAL */}
      {/* ============================================================ */}
      {showRowModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {rowForm.id === null ? "Add Row" : "Edit Row"}
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowRowModal(false)}
                  />
                </div>

                <div className="modal-body">
                  <label className="form-label">Order</label>
                  <input
                    className="form-control mb-3"
                    type="number"
                    value={rowForm.order}
                    onChange={(e) =>
                      setRowForm({ ...rowForm, order: Number(e.target.value) })
                    }
                  />

                  <h6 className="fw-bold">Labels</h6>
                  {LANGS.map((lang) => (
                    <input
                      key={lang}
                      className="form-control mb-2"
                      placeholder={`Label ${lang}`}
                      value={rowForm[`label${lang}`]}
                      onChange={(e) =>
                        setRowForm({
                          ...rowForm,
                          [`label${lang}`]: e.target.value,
                        })
                      }
                    />
                  ))}

                  <h6 className="fw-bold mt-3">2WD Values</h6>
                  {LANGS.map((lang) => (
                    <input
                      key={lang}
                      className="form-control mb-2"
                      placeholder={`2WD Value ${lang}`}
                      value={rowForm[`twoWdValue${lang}`]}
                      onChange={(e) =>
                        setRowForm({
                          ...rowForm,
                          [`twoWdValue${lang}`]: e.target.value,
                        })
                      }
                    />
                  ))}

                  <h6 className="fw-bold mt-3">4WD Values</h6>
                  {LANGS.map((lang) => (
                    <input
                      key={lang}
                      className="form-control mb-2"
                      placeholder={`4WD Value ${lang}`}
                      value={rowForm[`fourWdValue${lang}`]}
                      onChange={(e) =>
                        setRowForm({
                          ...rowForm,
                          [`fourWdValue${lang}`]: e.target.value,
                        })
                      }
                    />
                  ))}
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowRowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={saveRow}>
                    Save Row
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show" />
        </>
      )}
    </div>
  );
};

export default VoyahCourageSpecificationEditor;
